import { format, parseISO, parse, isValid } from 'date-fns';
import { Datum, isDatum, isStringArray } from '../types';

export const formatDate = (
  dat: Datum | Date | string | string[],
  hasTime = false
): string => {
  let date = null;

  if (isStringArray(dat)) {
    dat = dat[0];
  }

  if (typeof dat === 'string') {
    date = parseDate(dat);
  } else if (isDatum(dat)) {
    console.log('Is Datum: ' + dat.date);
    date = parseDate(dat.date);
  } else if (dat instanceof Date) {
    date = dat;
  } else if (dat === null || dat === undefined) {
    console.log('Null or undefined date');
  } else {
    logType('Unknown date type', dat);
  }

  if (date === null || date === undefined) {
    return '';
  }

  if (hasTime) {
    return format(date, 'dd-MM-yyyy HH:mm:ss');
  }

  return format(date, 'dd-MM-yyyy');
};

export const parseDate = (datum: string): Date | null => {
  let parsedDate = null;

  parsedDate = parseISO(datum);

  if (!isValid(parsedDate)) {
    // Try parsing SQL datetime format (YYYY-MM-DD HH:mm:ss)
    parsedDate = parse(datum.split('.')[0], 'yyyy-MM-dd HH:mm:ss', new Date());

    if (!isValid(parsedDate)) {
      // Try parsing just the date part
      parsedDate = parse(datum.split('.')[0], 'yyyy-MM-dd', new Date());
    }
  }

  if (!isValid(parsedDate)) {
    return null;
  }

  return parsedDate;
};

function logType(prefix: string, dat: any) {
  console.log('--- ' + prefix + ' ---');
  console.log('typeof dat:', typeof dat);
  console.log('dat === null:', dat === null);
  console.log('dat === string:', typeof dat === 'string');
  console.log('dat === undefined:', dat === undefined);
  console.log('Array.isArray(dat):', Array.isArray(dat));
  console.log(
    'Object.prototype.toString.call(dat):',
    Object.prototype.toString.call(dat)
  );
  console.log('dat:', dat);
  console.log('- END --- ' + prefix + ' --- END -');
}
